import {axiosApi} from "@/js/axios";

const state = {
    incidents: [],
    incident: {},
    incidentsCount: 0,
    perPage: 28,

    // Flags
    fetchingIncidents: false,
    fetchingIncident: false,
};

const getters = {
    pageCount: (state) => {
        return Math.ceil(state.incidentsCount / state.perPage);
    }
};

const actions = {
    fetchIncidents({state, commit, dispatch}, payload) {
        commit('SET_FETCHING_INCIDENTS', true);

        axiosApi.get(`/api/v2/incidents`, {
            params: {
                published: true,
                orderBy: 'name',
                direction: 'ASC',
                page: payload.page ? payload.page : 1,
                perPage: state.perPage
            }
        }).then(({data}) => {
            if (data) {
                commit('SET_INCIDENTS', data);
                commit('SET_INCIDENTS_COUNT', data);
                resolve(data)
            }
            commit('SET_FETCHING_INCIDENTS', false);
        }).catch(error => {
            commit('SET_FETCHING_INCIDENTS', false);
            reject(error);
        })
    },
    fetchIncident({commit}, payload) {
        commit('SET_FETCHING_INCIDENT', true);

        return new Promise((resolve, reject) => {
            axiosApi.get(`/api/v2/incidents/${payload.slug}`)
                .then(({data}) => {
                    if (data) {
                        commit('SET_INCIDENT', data);
                        resolve(data)
                    }
                    commit('SET_FETCHING_INCIDENT', false);
                })
                .catch(error => {
                    commit('SET_FETCHING_INCIDENT', false);
                    reject(error);
                })
        });
    },
};

const mutations = {
    SET_INCIDENTS(state, data) {
        state.incidents = data.data;
    },
    SET_INCIDENT(state, data) {
        state.incident = data;
    },
    SET_INCIDENTS_COUNT(state, data) {
        state.incidentsCount = data.total;
    },
    SET_FETCHING_INCIDENTS(state, value) {
        state.fetchingIncidents = value;
    },
    SET_FETCHING_INCIDENT(state, value) {
        state.fetchingIncident = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/incidents.js